import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, Loader2, Scale } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL 
  ? `${process.env.REACT_APP_BACKEND_URL}/api` 
  : '/api';

export default function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password.trim()) {
      toast.error('الرجاء إدخال كلمة المرور');
      return;
    }

    try {
      setLoading(true);
      console.log('Attempting login to:', `${API}/auth/login`);
      const response = await axios.post(`${API}/auth/login`, { password }, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 10000
      });
      console.log('Login response:', response.data);
      
      // Store token
      localStorage.setItem('token', response.data.token);
      
      toast.success('تم تسجيل الدخول بنجاح');
      onLogin(response.data.token);
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        toast.error('كلمة المرور غير صحيحة');
      } else if (error.code === 'ERR_NETWORK') {
        toast.error('خطأ في الاتصال بالخادم');
      } else {
        toast.error(`فشل تسجيل الدخول: ${error.message || 'خطأ غير معروف'}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center space-y-4">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
            <Scale className="w-10 h-10 text-blue-600" />
          </div>
          <div>
            <CardTitle className="text-2xl font-bold text-gray-900">
              نظام متابعة القضايا
            </CardTitle>
            <CardDescription className="text-gray-500 mt-2">
              الرجاء إدخال كلمة المرور للدخول
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="password" className="text-base font-medium">
                كلمة المرور
              </Label>
              <div className="relative">
                <Lock className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  id="password"
                  data-testid="password-input"
                  type="password"
                  placeholder="أدخل كلمة المرور"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pr-10 h-12 text-lg"
                  disabled={loading}
                  autoFocus
                />
              </div>
            </div>

            <Button
              data-testid="login-btn"
              type="submit"
              className="w-full h-12 text-base bg-blue-600 hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader2 className="w-5 h-5 ml-2 animate-spin" />
                  جاري الدخول...
                </>
              ) : (
                'دخول'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
